import { render, staticRenderFns } from "./IsClosedDialog.vue?vue&type=template&id=20e17056&"
import script from "./IsClosedDialog.vue?vue&type=script&lang=js&"
export * from "./IsClosedDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports